module.exports = __webpack_public_path__ + "static/media/post-3.f65fa729.png";